import { render, staticRenderFns } from "./AppendixValuation.vue?vue&type=template&id=69b27217&"
import script from "./AppendixValuation.vue?vue&type=script&lang=ts&"
export * from "./AppendixValuation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports